import { useMemo } from "react";
import { InfoAction } from "../data";

interface ContactoEmergenciaData {
  contactoEmergenciaNombre?: string;
  contactoEmergenciaParentesco?: string;
  contactoEmergencia?: string;
  cuil?: string;
}

export const useContactoEmergencia = (usuario: ContactoEmergenciaData) => {
  const actions: InfoAction[] = useMemo(() => {
    const hasContactoEmergencia = Boolean(
      usuario?.contactoEmergenciaNombre &&
        usuario?.contactoEmergenciaParentesco &&
        usuario?.contactoEmergencia
    );

    if (hasContactoEmergencia) {
      return [
        {
          action: "emergency_alert",
          usuario,
        } as any,
      ];
    }

    return [
      {
        action: "navigate",
        path: "/mi-cuenta",
        message: "Debe completar sus datos de contacto de emergencia",
      },
    ];
  }, [usuario]);

  return actions;
};
